export class Receipt {
	receiptText: string;
	emailFound: boolean;
	guestId: number;
	transactionId: number;
	transactionSourceType: string;
	transactionSourceTypeId: number;
	exportPdfData: string;
	ticketName: string;
	email: string;
	isTicketType: boolean;
	printTicketAfterPayment: string;
	printSkiDataAfterPayment: string;
	isContainsPdf: boolean;
	isSkiDataType: boolean;
	sendEmployeeNotification: boolean;
}
